import { render } from "./BebidasPrepradasView.vue?vue&type=template&id=11b9bac1"
import script from "./BebidasPrepradasView.vue?vue&type=script&lang=js"
export * from "./BebidasPrepradasView.vue?vue&type=script&lang=js"

import "./BebidasPrepradasView.vue?vue&type=style&index=0&id=11b9bac1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__